import { injectable } from 'tsyringe';
import { authClient } from '@/shared/AuthApiClient';

/** Keycloak native IdP representation (from GET /api/sso). */
export interface SsoConfig {
    alias: string;
    providerId: string;
    displayName: string;
    enabled: boolean;
    config: Record<string, string>;
}

export interface SaveSsoInput {
    alias: string;
    providerId: string;
    displayName: string;
    enabled: boolean;
    config: Record<string, string>;
}

@injectable()
export class SsoAdminService {
    async listConfigs(): Promise<SsoConfig[]> {
        const data = await authClient.ssoApi.getSso();
        return data as SsoConfig[];
    }

    async saveConfig(input: SaveSsoInput): Promise<void> {
        await authClient.ssoApi.postSave({ postSaveRequest: input });
    }

    async deleteConfig(alias: string): Promise<void> {
        await authClient.ssoApi.deleteByAlias({ alias });
    }
}
